import { call } from 'redux-saga/effects'
import reqProvider from '../coreRequests'
import { BASE_API } from '../urlPaths'

export function* getOrganizationTeamMembersDataService(orgId: string): any {
  const path = `${BASE_API}/organizations/${orgId}/users`
  const data: any = yield call(reqProvider.getReq, path)
  return data
}
